export default __webpack_public_path__ + "static/media/notice.2b1bdb33.svg";